







































































import Vue from "vue";
import iwSectionWithIcon from "@/encoding/components/layout/SectionWithIcon.vue";
import iwTypeOfHeating from "@/encoding/pages/questions/energy/TypeOfHeating.vue";
import iwHasHeatPump from "@/encoding/pages/questions/energy/HasHeatPump.vue";
import iwHasPhotovoltaicPanels from "@/encoding/pages/questions/energy/HasPhotovoltaicPanels.vue";
import iwHasThermicPanels from "@/encoding/pages/questions/energy/HasThermicPanels.vue";
import iwHasDoubleGlazing from "@/encoding/pages/questions/energy/HasDoubleGlazing.vue";
import iwHasCollectiveWaterHeater from "@/encoding/pages/questions/energy/HasCollectiveWaterHeater.vue";
import iwHasAirConditioning from "@/encoding/pages/questions/energy/HasAirConditioning.vue";
import iwEnergyConsumptionLevel from "@/encoding/pages/questions/energy/EnergyConsumptionLevel.vue";
import iwCo2Emission from "@/encoding/pages/questions/energy/Co2Emission.vue";
import iwGlobalThermalInsulationLevel from "@/encoding/pages/questions/energy/GlobalThermalInsulationLevel.vue";
import iwOilTankCertificateStatus from "@/encoding/pages/questions/energy/OilTankCertificateStatus.vue";
import iwReferenceNumberEpcReport from "@/encoding/pages/questions/energy/ReferenceNumberEpcReport.vue";
import iwEpcDescription from "@/encoding/pages/questions/energy/EpcDescription.vue";
import iwTotalEnergyTheoreticalConsumption from "@/encoding/pages/questions/energy/TotalEnergyTheoreticalConsumption.vue";
import iwEnergyConsumptionPerSqm from "@/encoding/pages/questions/energy/EnergyConsumptionPerSqm.vue";
import iwHasElectricalInstallationComplianceCertificate from "@/encoding/pages/questions/energy/HasElectricalInstallationComplianceCertificate.vue";
import iwEpcScore from "@/encoding/pages/questions/energy/EpcScore.vue";
import iwNextPreviousButton from "@/encoding/components/NextPreviousButton.vue";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import { updateClassified, validationClassified } from "@/shared/scripts/ValidateData";
import { mapActions, mapState } from "vuex";

export default Vue.extend({
    components: {
        iwSectionWithIcon: iwSectionWithIcon,
        iwTypeOfHeating: iwTypeOfHeating,
        iwHasHeatPump: iwHasHeatPump,
        iwHasPhotovoltaicPanels: iwHasPhotovoltaicPanels,
        iwHasThermicPanels: iwHasThermicPanels,
        iwHasDoubleGlazing: iwHasDoubleGlazing,
        iwHasCollectiveWaterHeater: iwHasCollectiveWaterHeater,
        iwHasAirConditioning: iwHasAirConditioning,
        iwEnergyConsumptionLevel: iwEnergyConsumptionLevel,
        iwCo2Emission: iwCo2Emission,
        iwEpcDescription: iwEpcDescription,
        iwReferenceNumberEpcReport: iwReferenceNumberEpcReport,
        iwTotalEnergyTheoreticalConsumption: iwTotalEnergyTheoreticalConsumption,
        iwEnergyConsumptionPerSqm: iwEnergyConsumptionPerSqm,
        iwGlobalThermalInsulationLevel: iwGlobalThermalInsulationLevel,
        iwOilTankCertificateStatus: iwOilTankCertificateStatus,
        iwHasElectricalInstallationComplianceCertificate: iwHasElectricalInstallationComplianceCertificate,
        iwEpcScore: iwEpcScore,
        iwNextPreviousButton: iwNextPreviousButton
    },

    data: function() {
        return {
            isButtonDisabled: false as boolean
        };
    },

    computed: {
        ...mapState("FormModule", ["isEditionMode"]),
        hasTypeOfEnergy: function(): boolean {
            return ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT", "OTHER", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        hasEnergyDocuments: function(): boolean {
            return ["HOUSE", "APARTMENT", "OFFICE","COMMERCIAL", "INDUSTRY", "OTHER", "GARAGE"].indexOf(this.getPropertyType()) !== - 1;
        },
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_step8_energy_performance_info");
    },

    methods: {
        ...mapActions({
            goToPreviousStep: "StepsWizard/previous",
            goToNextStep: "StepsWizard/next"
        }),
        clickNext: function(){
            this.isButtonDisabled = true;
            if (this.isEditionMode){
                validationClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            } else {
                this.isButtonDisabled = true;
                updateClassified((success:boolean) => {
                    Vue.nextTick(() => {
                        const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                        if (inputsError.length > 0) {
                            inputsError[0].focus();
                            window.scrollTo(0, 0);
                        }
                        this.isButtonDisabled = false;
                        this.goToNextStep();
                    });
                });
            }
        },
        clickPrevious: function(){

            this.goToPreviousStep();
        }
    }

});
